import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { PublishService } from 'src/app/pages/publish/publish.service';
import { AppSettings } from '../../carousal/carousal.settings';

@Component({
    selector: 'app-preview-carousal-modal',
    templateUrl: './preview-carousal-modal.component.html',
    styleUrls: ['./preview-carousal-modal.component.scss'],
})
export class PreviewCarousalModalComponent {
    @Input() data: any;
    cardData: any;
    orientation: any;
    settings: any;
    publish$?: Subscription;
    wholeData: any;

    constructor(private publishService: PublishService) {}

    ngOnInit() {
        this.publishService.getPublishModalData(this.data.productId, this.data.platformId, this.data.id);
        console.log(this.data);
        this.publish$ = this.publishService.publish$.subscribe((params: any) => {
            if (params) {
                switch (params.type) {
                    case 'PUBLISH_MODAL_DATA_SUCCESSFUL':
                        this.wholeData = params?.data[0]?.previewData;
                        break;
                }
            }
        });
    }

    ngOnDestroy() {
        this.publish$?.unsubscribe();
    }
}
